import React, { useContext } from 'react';

const ModalDialogNamespaceContext = React.createContext<undefined | string>(undefined);

export const useModalDialogNamespaceContext = () => useContext(ModalDialogNamespaceContext);

export default ModalDialogNamespaceContext;
